import React from 'react'
import { ChoiceGroup, DefaultButton, Panel, PanelType, PrimaryButton } from '@fluentui/react';
import Calendar from "react-calendar";
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';

import { useTranslation } from "react-i18next";

import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import "react-calendar/dist/Calendar.css";
import './style-calendar.css'
import { useBoolean } from '@fluentui/react-hooks';
import { useContext } from 'react';
import MainAppContext from '../../../../../MainAppContext';
import { nestedCopy, parseMesAnioEs, setBoardCalendarFilterConfig, setBoardFieldDisplay } from '../../../../../common/Helpers';
import { _global_buttonStyles } from '../../../../../common/ObjectStructures/Trasnversal';
import { enum__BoardCalendarFilter, __BoardCalendarFilter, __BoardFilterFields } from '../../../../../common/Dictionaries';
import PropTypes from 'prop-types';
import { action_setAllBoardViewNull, action_updateBoardDataseriesList } from '../../../../../reducers/actions/KPI/actions';
import { useDispatch } from 'react-redux';
import { cloneDeep } from 'lodash-es';

function CalendarFilterPanel(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const dispatch = useDispatch();

    const { 
        inputParam_IsPanelOpen = false,
        inputParam_SetterIsPanelOpen = null,
        inputParam_SetDataserieFullListToNull = null,
    } = props;
    
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [selectedStartDate, setSelectedStartDate] = useState([contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate, contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate]);
    const [fixedMonthDatesFilter, setFixedMonthDatesFilter] = useState({
        showPrincipalCalendar: contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId !== 9,
        showFixedMonthCalendar: contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId === 9
    });

    const onClickDate = (value) => {
        setSelectedStartDate(value);
    }

    const calendarConfigStructure = {
        maxDetail:"year",
        minDetail:"month",
        selectRange:true,
        showDoubleView: contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId !== 9 ? false : true,
        onChange:onClickDate,
        returnValue:"range"
    }

    const [calendarConfig, setCalendarConfig] = useState(calendarConfigStructure);
    const [calendarSelectorId, setCalendarSelectorId] = useState(contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId);
    

    const _onChange = (ev, option) => {
        let range = null;
        let showPrincipalCalendar = true;
        let showFixedMonthCalendar = false;

        switch (option.key) {
            case enum__BoardCalendarFilter.THIS_WEEK:
                range = [moment().startOf('isoWeek').toDate(), moment().endOf('isoWeek').toDate()]
                setCalendarConfig({
                    maxDetail:"month",
                    minDetail:"century",
                    selectRange:true,
                    showDoubleView:true,
                    onChange:onClickDate,
                    returnValue:"range"
                })
                showFixedMonthCalendar = false;
                showPrincipalCalendar = true
                break;
            case enum__BoardCalendarFilter.LAST_WEEK:
                range = [moment().subtract(1, 'isoWeek').startOf('isoWeek').toDate(), moment().subtract(1, 'isoWeek').endOf('isoWeek').toDate()]
                setCalendarConfig({
                    maxDetail:"month",
                    minDetail:"century",
                    selectRange:true,
                    showDoubleView:true,
                    onChange:onClickDate,
                    returnValue:"range"
                })
                showFixedMonthCalendar = false;
                showPrincipalCalendar = true
                break;
            case enum__BoardCalendarFilter.THIS_MONTH:
                range = [moment().startOf('month').toDate(), moment().endOf('month').toDate()]
                setCalendarConfig({
                    maxDetail:"year",
                    minDetail:"month",
                    selectRange:true,
                    showDoubleView:false,
                    onChange:onClickDate,
                    returnValue:"range"
                })
                showFixedMonthCalendar = false;
                showPrincipalCalendar = true
                break;
            case enum__BoardCalendarFilter.LAST_MONTH:
                range = [moment().subtract(1, 'month').startOf('month').toDate(), moment().subtract(1, 'month').endOf('month').toDate()]
                setCalendarConfig({
                    maxDetail:"year",
                    minDetail:"month",
                    selectRange:true,
                    showDoubleView:false,
                    onChange:onClickDate,
                    returnValue:"range"
                })
                showFixedMonthCalendar = false;
                showPrincipalCalendar = true
                break;
            case enum__BoardCalendarFilter.THIS_QUARTER:
                range = [moment().startOf('quarter').toDate(), moment().endOf('quarter').toDate()]
                setCalendarConfig({
                    maxDetail:"year",
                    minDetail:"month",
                    selectRange:true,
                    showDoubleView:false,
                    onChange:onClickDate,
                    returnValue:"range"
                })
                showFixedMonthCalendar = false;
                showPrincipalCalendar = true
                break;
            case enum__BoardCalendarFilter.LAST_QUARTER:
                range = [moment().subtract(1, 'quarter').startOf('quarter').toDate(), moment().subtract(1, 'quarter').endOf('quarter').toDate()]
                setCalendarConfig({
                    maxDetail:"year",
                    minDetail:"month",
                    selectRange:true,
                    showDoubleView:false,
                    onChange:onClickDate,
                    returnValue:"range"
                })
                showFixedMonthCalendar = false;
                showPrincipalCalendar = true
                break;
            case enum__BoardCalendarFilter.THIS_YEAR:
                range = [moment().startOf('year').toDate(), moment().endOf('year').toDate()]
                setCalendarConfig({
                    maxDetail:"decade",
                    minDetail:"decade",
                    selectRange:false,
                    showDoubleView:false,
                    onChange:onClickDate,
                    returnValue:"start"
                })
                showFixedMonthCalendar = false;
                showPrincipalCalendar = true
                break;
            case enum__BoardCalendarFilter.LAST_YEAR:
                range = [moment().subtract(1, 'year').startOf('year').toDate(), moment().subtract(1, 'year').endOf('year').toDate()]
                setCalendarConfig({
                    maxDetail:"decade",
                    minDetail:"decade",
                    selectRange:false,
                    showDoubleView:false,
                    returnValue:"start"
                })
                showFixedMonthCalendar = false;
                showPrincipalCalendar = true
                break;
            case enum__BoardCalendarFilter.FIXED_MONTH:
                range = [moment().toDate(), moment().toDate()]
                setCalendarConfig({
                    maxDetail:"year",
                    minDetail:"month",
                    selectRange:true,
                    showDoubleView:true,
                    onChange:onClickDate,
                    returnValue:"range"
                })
                showFixedMonthCalendar = true;
                showPrincipalCalendar = false
                break;
            default:
                break;
        }

        setSelectedStartDate(range);

        setCalendarSelectorId(option.key)

        setFixedMonthDatesFilter({showPrincipalCalendar: showPrincipalCalendar, showFixedMonthCalendar: showFixedMonthCalendar})
    }
    
    const onFilter = (e) => {
        const rangeStart = document.querySelector('.react-calendar__tile--rangeStart');
        const rangeEnd = document.querySelector('.react-calendar__tile--rangeEnd');

        let periodStartDate;
        let periodEndsDate;

        contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId = calendarSelectorId
        contextSite.kpiModule.boardCalendarFilterConfig.value.fireFilter = true
        
        if (rangeStart && rangeEnd && contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId === 9) {
            const startMonth = rangeStart.children[0].getAttribute('aria-label');
            const endMonth = rangeEnd.children[0].getAttribute('aria-label');

            // Comparar los meses
            if (startMonth === endMonth) {
                const date = parseMesAnioEs(startMonth);

                const fechaInicial = parseMesAnioEs(startMonth);
                const fechaFinal = date.endOf('month').toDate();

                contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate = fechaFinal
                contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate =fechaInicial

                periodStartDate = moment(fechaInicial).toDate();
                periodEndsDate = moment(fechaFinal).toDate();

                setSelectedStartDate([fechaInicial, fechaFinal]);
            }
            else {
                const fechaInicial = parseMesAnioEs(startMonth);
                const fechaFinal = parseMesAnioEs(endMonth).toDate();
                
                contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate = fechaFinal
                contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate =fechaInicial

                periodStartDate = moment(fechaInicial).toDate();
                periodEndsDate = moment(fechaFinal).toDate();

                setSelectedStartDate([fechaInicial, fechaFinal]);
            }
        }
        else{
            contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate = selectedStartDate[1]
            contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate = selectedStartDate[0]

            periodStartDate = moment(selectedStartDate[0]).toDate();
            periodEndsDate = moment(selectedStartDate[1]).toDate();
        }

        setBoardCalendarFilterConfig(contextSite.kpiModule.boardCalendarFilterConfig.value)
        
        contextSite.kpiModule.boardCalendarFilterConfig.setter(prevState => ({
            ...prevState,
            fireFilter: true,
            calendarSelectorId: calendarSelectorId,
            periodStartDate: contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate,
            periodEndsDate: contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate
        }))

        dispatch(action_updateBoardDataseriesList(null, true));

        
        dispatch(action_setAllBoardViewNull());

        inputParam_SetDataserieFullListToNull && inputParam_SetDataserieFullListToNull(prevState => ({
            ...prevState,
            revisionDataserieFullList: null,
            gapFishboneList: null,
            fireUpdateLastAction: true
        }))

        if (!(calendarSelectorId === 3 || (calendarSelectorId === 9 && (periodStartDate.getMonth() === periodEndsDate.getMonth() && periodStartDate.getYear() === periodEndsDate.getYear())))){
            let newValues = cloneDeep(__BoardFilterFields).filter(x => x.isChecked).map(({ field, simbol }) => ({ field: field, simbol: simbol}));
            setBoardFieldDisplay(newValues)
        }

        window.location.href = window.location.href;

        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return <div>
                    <PrimaryButton onClick={onFilter} styles={_global_buttonStyles}>{t('data-lang-btn-filter')}</PrimaryButton>
                    <DefaultButton onClick={onClosePanel}>{t('data-lang-btn-close')}</DefaultButton>
                </div>
    }

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };
    
    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
    };

    const onClosePanel = () => {
        onDismissPanel();
    };

    return (
        <>
            <div>
                <Panel
                    isOpen={ inputParam_IsPanelOpen }
                    isLightDismiss={ true }
                    onLightDismissClick={ showDialog }
                    onDismiss={ onDismissPanel }
                    headerText={ t('data-lang-boxname-filters') }
                    closeButtonAriaLabel={ t('data-lang-btn-close') }
                    isFooterAtBottom={ true }
                    onRenderFooterContent={ onRenderFooterContent }
                    customWidth={ PanelType.medium }
                    type={ PanelType.medium }
                >
                    <Row className="pt-3">
                        <Col xl={9} align="center">
                            <div className='calendar-layer-block'>
                                {
                                fixedMonthDatesFilter.showPrincipalCalendar &&
                                    <>
                                        <Calendar
                                            className={"disabledbutton box"}
                                            onChange={onClickDate}
                                            returnValue={calendarConfig.returnValue}
                                            value={selectedStartDate ? selectedStartDate : null}
                                            selectRange={calendarConfig.selectRange}
                                            showNeighboringMonth={false}
                                            maxDate={new Date()}
                                            minDetail={calendarConfig.minDetail}
                                            maxDetail={calendarConfig.maxDetail}
                                            showDoubleView={calendarConfig.showDoubleView}
                                            formatLongDate={(locale, date) => moment(date).format("DD/MM/YYYY")}
                                            locale={"es-ES"}
                                        />
                                        <div className='box overlay'></div>
                                    </>
                                }
                                {
                                    fixedMonthDatesFilter.showFixedMonthCalendar &&
                                    <Calendar
                                        className={"disabledbutton box"}
                                        onChange={onClickDate}
                                        returnValue={calendarConfig.returnValue}
                                        value={selectedStartDate ? selectedStartDate : null}
                                        selectRange={calendarConfig.selectRange}
                                        showNeighboringMonth={false}
                                        maxDate={new Date()}
                                        minDetail={calendarConfig.minDetail}
                                        maxDetail={calendarConfig.maxDetail}
                                        showDoubleView={calendarConfig.showDoubleView}
                                        formatLongDate={(locale, date) => moment(date).format("DD/MM/YYYY")}
                                        locale={"es-ES"}
                                    />
                                }
                            </div>
                        </Col>
                        <Col xl={3}>
                            <ChoiceGroup
                                defaultSelectedKey={contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId}
                                options={
                                    nestedCopy(__BoardCalendarFilter).map(element => {
                                        element.text = t(element.text);
                                        return element
                                    })
                                }
                                onChange={_onChange} label={t('data-lang-lbl-select')}
                                required={true} />
                        </Col>
                    </Row>
                </Panel>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </div>            
        </>
    );
}

CalendarFilterPanel.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
    inputParam_SetDataserieFullListToNull: PropTypes.func,
};

export default CalendarFilterPanel;